import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';

const claimProjectReportsOverviewService = {
  all: (queryParams) => {
    return fetch(`/api/overview/claim_project_reports?${queryParams}`, request.get);
  },
};

export default claimProjectReportsOverviewService;